import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ILead, IDropdown } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVTextArea } from "../../shared/JVTextarea";

const schema = yup.object({
    statusId: yup.number().required("Status is required").min(1, "Status is required"),
    comment: yup.string().nullable(),
});

interface Iprops {
    singleData: ILead,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Form = (props: Iprops) => {
    const [status, setStatus] = useState<IDropdown[]>();
    const [submitting, setSubmitting] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset } = useForm<ILead>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    useEffect(() => {
        loadStatus();
    }, []);

    useEffect(() => {
        if (props.singleData.id) props.singleData.contact = { id: props.singleData.contactId || 0, name: props.singleData.contactName + ' | ' + props.singleData.contactContact };
        reset(props.singleData);
    }, [props.singleData]);

    const loadStatus = async () => {
        const response = await Fetch("status/dropdown", "GET", null, null, null);
        if (response) {
            setStatus(await response.json());
        }
    }

    const saveToDB = async (body: ILead) => {
        setSubmitting(true);
        body.contactId = body.contact?.id;
        delete body.contact;
        const response = await Fetch(`lead/mylead${props.singleData.id ? '/' + props.singleData.id : ''}`, "PUT", body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: "Updated Successfully", life: 3000 });
            props.reloadData();
        }
        setSubmitting(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset({});
    }

    function onSubmit(data: ILead) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '400px' }} header={`Update Lead Status (${props.singleData.contactName} | ${props.singleData.contactContact})`} modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdown column={1} required label="Status" control={control} options={status} optionLabel="name" optionValue="id" name="statusId" placeholder="Select Status" error={errors.statusId?.message} />
                <JVTextArea column={1} label="Comment" control={control} name="comment" placeholder="Write your comment here..." />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}